import SparkMD5 from 'spark-md5';

export type ComputeFileMd5Progress = {
  processedBytes: number;
  totalBytes: number;
  percent: number;
};

export const computeFileMd5OnMainThread = async (
  file: File | Blob,
  chunkSize: number,
  onProgress?: (progress: ComputeFileMd5Progress) => void
): Promise<Uint8Array> => {
  const spark = new SparkMD5.ArrayBuffer();
  let offset = 0;

  const reportProgress = () => {
    if (!onProgress) return;

    const totalBytes = file.size;
    const processedBytes = Math.min(offset, totalBytes);
    const percent =
      totalBytes === 0 ? 100 : Math.round((processedBytes / totalBytes) * 100);

    onProgress({ processedBytes, totalBytes, percent });
  };

  while (offset < file.size) {
    const slice = file.slice(offset, offset + chunkSize);
    const buffer = await slice.arrayBuffer();
    spark.append(buffer);
    offset += chunkSize;
    reportProgress();
  }

  if (file.size === 0) reportProgress();

  const rawHash = spark.end(true);
  const bytes = new Uint8Array(rawHash.length);
  for (let i = 0; i < rawHash.length; i++) {
    bytes[i] = rawHash.charCodeAt(i);
  }

  return bytes;
};
